import _defineProperty from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "testId", "className", "as"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { jsx as c } from "react/jsx-runtime";
import { forwardRef as f } from "react";
import p from "classnames";
import l from "./Button.module.scss.js";
var B = f(function (o, s) {
  var r = o.children,
    a = o.testId,
    e = o.className,
    m = o.as,
    t = _objectWithoutProperties(o, _excluded),
    n = m || (t.href ? "a" : "button");
  return /* @__PURE__ */c(n, _objectSpread(_objectSpread({
    className: p([l.baseButton, e]),
    "data-cy": a,
    ref: s
  }, t), {}, {
    children: r
  }));
});
export { B as default };